import { render, staticRenderFns } from "./indexYGS.vue?vue&type=template&id=1421a4f4&scoped=true&"
import script from "./indexYGS.vue?vue&type=script&lang=js&"
export * from "./indexYGS.vue?vue&type=script&lang=js&"
import style0 from "./indexYGS.vue?vue&type=style&index=0&id=1421a4f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1421a4f4",
  null
  
)

export default component.exports